<template>
	<div class="home-menu-items apps">
		<div class="d-flex pb-15 bar">
			<span class="flex-1 back" @click='$router.replace(`/m/${parentid||""}`)' v-if='id>0'><van-icon name="arrow-left" />返回上级</span>
			<span class="flex-1" v-else></span>
			<div class="apps-title d-flex" middle>{{title}}</div>
			<span class="flex-1 pr-10"></span>
		</div>
		<div class="app-items">
			<component :is="item.menuType=='group'?'group':item.appType" :class="{'ready':item.status===1}" :item='item' v-for='(item) in items' :key='item.id' />
			<template v-if='12-items.length>1'>
				<div class="app-item empty" v-for='n in 12-items.length' :key='n'></div>
			</template>
		</div>
	</div>
</template>
<script>
	import { mapModules, mapRules } from "vuet";
	import wxmini from "./menu/wxmini.vue";
	import h5 from "./menu/h5.vue";
	import group from "./menu/group.vue";
	export default {
		mixins: [
			mapModules({
				data: "root/home",
			}),
		],
		components: {
			wxmini,
			mobileh5: h5,
			group,
		},
		data() {
			return {
				user: this.$config.userinfo,
			};
		},
		computed: {
			id() {
				return parseInt(this.data.id) || 0;
			},
			parentid() {
				if (this.current) {
					return this.current.parentId;
				} else {
					return "";
				}
			},
			current() {
				return this.data.list.find((x) => x.id == this.id);
			},
			items() {
				var id = this.id;
				return this.data.list.filter((x) => x.parentId === id);
			},
			title() {
				var item = this.data.list.find((x) => x.id == this.id);
				var t = "服务一件事";
				if (item) {
					t = item.name;
				}
				return t;
			},
		},
		watch: {
			$route(v) {
				this.data.id = parseInt(this.$route.params["id"]);
			},
		},
	};
</script>
<style lang="less">
.home-menu-items {
	position: relative;
	padding-top: 20px;
	padding-bottom: 10px;
	padding-left: 10px;
	background-color: white;

	.bar{
		align-items: baseline;
	}

	.back {
		color: @main;
		font-size: 15px;
	}

	.apps-title {
		text-align: center;
		color: @main;
		font-weight: bolder;
	}

	.app-items {
		padding-left: 10px;
	}

	.app-item {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		vertical-align: top;
		background-color: lighten(@main, 15%);
		width: 73px;
		height: 73px;
		margin-right: 15px;
		margin-bottom: 15px;
		border-radius: 5px;
		text-align: center;
		position: relative;

		wx-open-launch-weapp,.miniitem {
			display: inline-block;
			opacity: 0;
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0px;
			left: 0px;
			z-index: 1;
		}

		&:focus {
			background-color: @main;
		}

		&.ready {
			background-color: lighten(#eeeeee, 10%);
			border: 1px dashed #dddddd;

			.text {
				color: #b5b4b4;
			}

			&::before {
				display: inline-block;
				content: "准备中...";
				position: absolute;
				top: -8px;
				right: -8px;
				font-size: 10px;
				background-color: #eeeeee;
				padding: 1px 3px;
				color: #b5b4b4;
				border-radius: 10px;
				z-index: 100;
			}
		}

		&.empty {
			border: 1px dashed #eeeeee;
			background-color: lighten(#eeeeee, 5%);

			&::before {
				content: "虚位以待";
				font-size: 12px;
				color: #dddddd;
			}
		}

		.van-image {
			width: 33px;
		}

		.text {
			font-size: 13px;
			color: #d2931e;
			line-height: 10px;
			transform: translateY(2px);
		}
	}
}
</style>